export default function ActionCards() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950">
            Links Verificados
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-3">
            Mais de 500 produtos com qualidade garantida
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-primary-50 rounded-3xl p-5 md:p-6 flex flex-col">
            <div className="w-full h-[220px] md:h-[260px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Fashion%20sneakers%20and%20accessories%20on%20cream%20paper%20backdrop%2C%20soft%20studio%20lighting%2C%20editorial%20product%20flatlay%2C%20warm%20olive%20and%20sand%20palette%2C%20minimalist%20elegance%2C%20clean%20composition%2C%20lifestyle%20aesthetic&width=600&height=520&seq=card-planilha-v2&orientation=landscape"
                alt="Planilha CSSBuy"
                title="CSSBuy Spreadsheet Verificada"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-foreground-950 font-bold text-lg mt-5 text-center">
              Planilha Completa
            </h3>
            <p className="text-foreground-500 text-sm mt-2 text-center">
              Acesso a todos os links CSSBuy
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-5 bg-foreground-950 text-white font-semibold px-6 py-3 rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-all duration-200 text-center"
            >
              Ver Planilha
            </a>
            <p className="text-foreground-400 text-xs mt-2 text-center">
              +500 links atualizados semanalmente
            </p>
          </div>

          <div className="bg-white rounded-3xl p-5 md:p-6 flex flex-col border border-background-200">
            <div className="w-full h-[220px] md:h-[260px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Boutique%20clothing%20store%20display%20with%20folded%20garments%2C%20warm%20ambient%20lighting%2C%20cream%20and%20beige%20tones%2C%20minimalist%20retail%20aesthetic%2C%20editorial%20interior%20photography%2C%20elegant%20shopping%20atmosphere&width=600&height=520&seq=card-loja-v2&orientation=landscape"
                alt="Loja CSSBuy"
                title="Acessar Loja CSSBuy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-foreground-950 font-bold text-lg mt-5 text-center">
              Acessar Loja
            </h3>
            <p className="text-foreground-500 text-sm mt-2 text-center">
              Explore a loja completa
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-5 border-2 border-foreground-950 text-foreground-950 font-semibold px-6 py-3 rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-50 transition-all duration-200 text-center"
            >
              Acessar Loja
            </a>
            <p className="text-foreground-400 text-xs mt-2 text-center">
              Produtos verificados e seguros
            </p>
          </div>

          <div className="bg-white rounded-3xl p-5 md:p-6 flex flex-col border border-background-200">
            <div className="w-full h-[220px] md:h-[260px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Curated%20lifestyle%20products%20on%20textured%20linen%20fabric%2C%20warm%20morning%20sunlight%2C%20Mediterranean%20aesthetic%2C%20terracotta%20vase%20and%20woven%20basket%2C%20editorial%20still%20life%2C%20organic%20natural%20textures&width=600&height=520&seq=card-explorar-v2&orientation=landscape"
                alt="Explorar Produtos CSSBuy"
                title="Explorar Produtos CSSBuy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-foreground-950 font-bold text-lg mt-5 text-center">
              Explorar Produtos
            </h3>
            <p className="text-foreground-500 text-sm mt-2 text-center">
              Navegue por categorias
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-5 border-2 border-foreground-950 text-foreground-950 font-semibold px-6 py-3 rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-50 transition-all duration-200 text-center"
            >
              Explorar Produtos
            </a>
            <p className="text-foreground-400 text-xs mt-2 text-center">
              14 categorias disponíveis
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}